import { render, staticRenderFns } from "./travelService.vue?vue&type=template&id=68e4d0f9&scoped=true&"
import script from "./travelService.vue?vue&type=script&lang=js&"
export * from "./travelService.vue?vue&type=script&lang=js&"
import style0 from "./travelService.vue?vue&type=style&index=0&id=68e4d0f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e4d0f9",
  null
  
)

export default component.exports